
import { cloneDeep } from 'lodash';
import { NodeType } from '@amplify/amp-module';
import { NodeSizes } from '@/constants/builder';
import { isButtonMultiline } from '@/utils/builder-utils';
import NodeWrapper from '@/components/graph/common/NodeWrapper';
import { useNodeUtils } from '@/composables/useNodeUtils';
import ButtonSubNode from '@/components/graph/nodes/groups/button/ButtonSubNode.vue';

export default {
  components: { ButtonSubNode, NodeWrapper },

  setup() {
    const nodeType = NodeType.buttonGroup;
    const maxStorageSize = NodeSizes[nodeType].width;

    const {
      ampData,
      canEditAmp,
      uiData,
      nodeId,
      nodeRef,
      nodeSelf,
      selectedSubNodeIndex,
      subNodesArray,
      addStorageOption,
      addSubNode,
      deleteStorage,
      onSelectSubNode,
      updateDelay,
    } = useNodeUtils({ nodeType });

    const nodeActions = [{ key: 'right', handler: addSubNode }];

    // same function is used in QuestionNode
    const onUpdateSubNode = (data) => {
      const { id } = data;
      const subNodes = cloneDeep(ampData.value.subNodes);
      const hadMultilineContent = Object.values(subNodes || {}).some((subNode) =>
        isButtonMultiline(subNode.buttonTexts)
      );

      subNodes[id] = data;
      ampData.value = { ...ampData.value, subNodes };

      const hasMultilineContent = Object.values(subNodes || {}).some((subNode) =>
        isButtonMultiline(subNode.buttonTexts)
      );

      const { width, height } = nodeSelf.value.size();

      if (hadMultilineContent && !hasMultilineContent) {
        nodeSelf.value.resize(width, height - 28);
      }

      if (!hadMultilineContent && hasMultilineContent) {
        nodeSelf.value.resize(width, height + 28);
      }
    };

    return {
      ampData,
      canEditAmp,
      maxStorageSize,
      nodeActions,
      nodeId,
      nodeRef,
      nodeSelf,
      nodeType,
      uiData,
      selectedSubNodeIndex,
      subNodesArray,
      addStorageOption,
      deleteStorage,
      updateDelay,
      onSelectSubNode,
      onUpdateSubNode,
    };
  },
};
